import Get from 'lodash.get';

export default (response) => {
  return {
    current_level_description: Get(response,'data.attempt_level_up.current_level_value.description',''),
    next_level_description: Get(response,'data.attempt_level_up.next_level_value.description',''),
    kyc_level_status: Get(response,'data.attempt_level_up.kyc_level_status','')
  };
};
